export default {
  nav: {
    title: 'Chat',
  },
  admin: {
    title: 'Chat Administration',
    subtitle: 'Roles and permissions for chat access.',
    authorization: 'Authorization',
    conversations: 'Conversations',
    userAccess: 'User Access',
    refresh: 'Refresh',
    reset: 'Reset',
    search: 'Search',
    role: 'Role',
    permissions: 'Permissions',
    noRoles: 'No chat roles are configured.',
    addUser: 'Add user',
    addAccess: 'Add access',
    removeAccess: 'Remove access',
    user: 'User',
    roles: 'Roles',
    access: 'Access',
    noUserAccess: 'No users have the Chat User role.',
    userId: 'Participant user',
    type: 'Type',
    messageFrom: 'Messages from',
    messageUntil: 'Messages until',
    createdFrom: 'Created from',
    createdUntil: 'Created until',
    conversation: 'Conversation',
    participants: 'Participants',
    lastMessage: 'Last message',
    activity: 'Activity',
    noConversations: 'No conversations match these filters.',
    previous: 'Previous',
    next: 'Next',
  }
}
